// Pick by the saved app language — for small presentational spots outside a component that reads useLanguage.
export const LS = (en, es) => {
  try { return localStorage.getItem('appLanguage') === 'es' ? es : en; } catch { return en; }
};
